/* eslint-disable no-unused-vars */
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Loader } from 'components';
import { ImageSizeInput } from './bannerBoxComponents/imageSizeInput/ImageSizeInput';
import { UploadImage } from './bannerBoxComponents/uploadImage/UploadImage';
import { BannersList } from './bannerBoxComponents/bannersList/BannersList';
import { useSignal } from '@preact/signals-react';
import { manageCreativeMediaAPI } from 'services/manageCreativeMedia.service';
import { isAdminSelector, select_campaign_env } from 'store/selectors';
import { campaignEnvironment } from 'constants';

export const BannersTab = ({ isNewCreative }) => {
  const { data, isLoading, isFetching, isError } =
    manageCreativeMediaAPI.useGetCreativeimageTypesQuery();
  const currentSelectedSize$ = useSignal('');
  const previewSectionImage$ = useSignal(null);

  const isAdmin = useSelector(isAdminSelector);
  const environment = useSelector(select_campaign_env);
  const isDisabled = !isAdmin && environment === campaignEnvironment.edit && !isNewCreative;

  const detectWidthAndHeight = useCallback(
    (imageType) => {
      if (data) {
        const imageSize = data.find((data) => +data.imageType === +imageType)?.imageSize;
        const [width, height] = imageSize.split('x').map(Number);
        return { width, height };
      }
      return { width: 0, height: 0 };
    },
    [data],
  );

  if (isLoading) {
    return (
      <div style={{ height: '200px', display: 'flex', alignItems: 'center' }}>
        <Loader.Local delay={0} />
      </div>
    );
  }
  return (
    <div style={{ marginTop: '32px', display: 'flex', gap: '32px' }}>
      <div
        style={{
          flex: '1',
          display: 'flex',
          gap: '32px',
          flexDirection: 'column',
          maxWidth: 'calc(50% - 32px)',
        }}
      >
        <ImageSizeInput
          data={data}
          currentSelectedSize$={currentSelectedSize$}
          previewSectionImage$={previewSectionImage$}
          isDisabled={isDisabled}
        />
        <BannersList
          previewSectionImage$={previewSectionImage$}
          currentSelectedSize$={currentSelectedSize$}
          isDisabled={isDisabled}
        />
      </div>
      <div style={{ flex: '1' }}>
        <UploadImage
          previewSectionImage$={previewSectionImage$}
          currentSelectedSize$={currentSelectedSize$}
          detectWidthAndHeight={detectWidthAndHeight}
          isDisabled={isDisabled}
        />
      </div>
    </div>
  );
};
